import { Modal } from "react-bootstrap";
import methods from "../../../services/utility";

const CreditDetailModal = ({ show, onHide, data }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="confirm-delete"
    >
      <Modal.Header closeButton>
        جزئیات
      </Modal.Header>
      <Modal.Body>
        {data.length ? 
        <table className="table table-bordered table-striped text-center">
          <thead className="align-middle">
            <tr>
              <th>نام مشتری</th>
              <th>کد مشتری</th>
              <th>فروش خالص</th>
              <th>مالیات بر ارزش افزوده</th>
              <th>مبلغ پرداختی</th>
              <th>انعام</th>
              <th>تخفیف</th>
              <th>جمع کل</th>
            </tr>
          </thead>
          <tbody className="align-middle">
            {data?.map((item) => (
              <tr key={item.userId}>
                <td>{item.merchantName}</td>
                <td>{item.merchantCode}</td>
                <td>{methods.addNumSeperator(item.netAmount)}</td>
                <td>{methods.addNumSeperator(item.taxAmount)}</td>
                <td>{methods.addNumSeperator(item.paymentAmount)}</td>
                <td>{methods.addNumSeperator(item.tipAmount)}</td>
                <td>{methods.addNumSeperator(item.discountAmount)}</td>
                <td>{methods.addNumSeperator(item.finalAmount)}</td>
              </tr>
            ))}
          </tbody>
        </table> : <span className="d-block text-center">جزییات اعتباری وجود ندارد</span>}
      </Modal.Body>
    </Modal>
  );
};

export default CreditDetailModal;
